/**
 * @desc 根据时间获取月计划id
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.DateRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/web/plan/week/queryMonthPlanId',
    data,
  });
}

export function mock(
  data: defs.DateRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/mock/web/plan/week/queryMonthPlanId',
    data,
  });
}
